import { getArray, getSubArray } from "../../../common";
import * as mappers from "../../mappers";
const mapEvent = (x) => mappers.mapEvent(x[1]);
const mapOffer = (x) => mappers.mapOffer(x[1]);
export function mapMarketOffersResponse(data) {
    const add = getSubArray(data, 0, 0);
    const marketsAdd = getArray(add, 0);
    const selectionsAdd = getArray(add, 1);
    const remove = getSubArray(data, 0, 1);
    const marketsRemove = getArray(remove, 0);
    const selectionsRemove = getArray(remove, 1);
    const change = getSubArray(data, 0, 2);
    const marketsChange = getArray(change, 0);
    const selectionsChange = getArray(change, 1);
    const response = {
        data: {
            add: {
                markets: marketsAdd.map((x) => mappers.mapMarketOffersSelectionsUpdates(x[1])),
                selections: selectionsAdd.map((x) => mappers.mapMarketOffersSelectionsUpdate(x[1])),
            },
            change: {
                markets: marketsChange.map((x) => mappers.mapMarketOffersSelectionsUpdates(x[1])),
                selections: selectionsChange.map((x) => mappers.mapMarketOffersSelectionsUpdate(x[1])),
            },
            remove: {
                markets: marketsRemove,
                selections: selectionsRemove,
            },
        },
        metadata: data[2] || undefined
    };
    return response;
}
export function mapEventResponse(data) {
    const add = getSubArray(data, 0, 0);
    const eventsAdd = getArray(add, 0);
    const marketsAdd = getArray(add, 1);
    const remove = getSubArray(data, 0, 1);
    const eventsRemove = getArray(remove, 0);
    const marketsRemove = getArray(remove, 1);
    const change = getSubArray(data, 0, 2);
    const eventsChange = getArray(change, 0);
    const marketsChange = getArray(change, 1);
    const response = {
        data: {
            add: {
                events: eventsAdd.map(mapEvent),
                markets: marketsAdd.map(mapOffer),
            },
            change: {
                events: eventsChange.map(mapEvent),
                markets: marketsChange.map(mapOffer),
            },
            remove: {
                events: eventsRemove,
                markets: marketsRemove,
            },
        },
        metadata: data[2] || undefined
    };
    return response;
}
export function mapSportsbookProjectionResponse(data) {
    const add = getSubArray(data, 0, 0);
    const eventsAdd = getArray(add, 0);
    const marketsAdd = getArray(add, 1);
    const selectionsAdd = getArray(add, 2);
    const leaguesAdd = getArray(add, 3);
    const sportsAdd = getArray(add, 4);
    const remove = getSubArray(data, 0, 1);
    const eventsRemove = getArray(remove, 0);
    const marketsRemove = getArray(remove, 1);
    const selectionsRemove = getArray(remove, 2);
    const change = getSubArray(data, 0, 2);
    const eventsChange = getArray(change, 0);
    const marketsChange = getArray(change, 1);
    const selectionsChange = getArray(change, 2);
    const response = {
        data: {
            add: {
                leagues: leaguesAdd.map((x) => mappers.mapSportsbookLeague(x[1])),
                events: eventsAdd.map((x) => mappers.mapSportsbookEventPull(x[1])),
                markets: marketsAdd.map((x) => mappers.mapSportsbookMarket(x[1])),
                selections: selectionsAdd.map((x) => mappers.mapSportsbookSelection(x[1])),
                sports: sportsAdd.map((x) => mappers.mapSportsbookSport(x[1]))
            },
            change: {
                events: eventsChange.map((x) => mappers.mapSportsbookEventUpdate(x[1])),
                markets: marketsChange.map((x) => mappers.mapSportsbookMarketsUpdate(x[1])),
                selections: selectionsChange.map((x) => mappers.mapSportsbookSelectionsUpdate(x[1])),
            },
            remove: {
                events: eventsRemove,
                markets: marketsRemove,
                selections: selectionsRemove,
            },
        },
        metadata: data[2]
    };
    return response;
}
export function mapMarketsResponse(data) {
    const add = getSubArray(data, 0, 0);
    const remove = getSubArray(data, 0, 1);
    const change = getSubArray(data, 0, 2);
    const response = {
        data: {
            add: add.map(mapOffer),
            change: change.map(mapOffer),
            remove,
        },
        metadata: data[2] || undefined
    };
    return response;
}
//# sourceMappingURL=mapResponses.js.map